import { useNavigate } from "@tanstack/react-router";
import { TabBar } from "@/components/ui/tab-bar";
import { PagesSection } from "./PagesSection";
import { FaqSection } from "./FaqSection";
import { MediaSection } from "./MediaSection";
import { FeaturedTherapistsSection } from "./FeaturedTherapistsSection";
import { HomepageTopicsSection } from "./HomepageTopicsSection";
import { TestimonialsSection } from "./TestimonialsSection";
import { FooterSettingsSection } from "./FooterSettingsSection";

export type ContentTab = "pages" | "faq" | "media" | "featured" | "topics" | "testimonials" | "footer";

export const CONTENT_TABS: Array<{ value: ContentTab; label: string }> = [
  { value: "pages", label: "Pages" },
  { value: "faq", label: "FAQ" },
  { value: "media", label: "Media" },
  { value: "featured", label: "Featured" },
  { value: "topics", label: "Teme" },
  { value: "testimonials", label: "Testimoniali" },
  { value: "footer", label: "Footer" },
];

export function isContentTab(value: unknown): value is ContentTab {
  return typeof value === "string" && CONTENT_TABS.some((t) => t.value === value);
}

export function ContentPage({ tab }: { tab: ContentTab }) {
  const navigate = useNavigate({ from: "/dashboard/admin/content" });
  const setTab = (next: string) => navigate({ search: { tab: next as ContentTab } });

  return (
    <div className="mx-auto max-w-6xl space-y-5 pb-14 sm:space-y-6">
      <header>
        <h1
          className="text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Sadržaj
        </h1>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          Javne stranice, FAQ, media biblioteka, istaknuti terapeuti, teme na
          početnoj i footer.
        </p>
      </header>

      <div className="flex flex-col gap-3 border-b border-border/60 pb-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-lg font-semibold leading-none tracking-tight text-foreground" style={{ fontFamily: "var(--font-heading)" }}>
          Sekcije sadržaja
        </h2>
        <TabBar
          tabs={CONTENT_TABS}
          value={tab}
          onChange={setTab}
          ariaLabel="Sekcije sadržaja"
          mobileMode="select"
        />
      </div>

      <div className="min-w-0">
        {tab === "pages" && <PagesSection />}
        {tab === "faq" && <FaqSection />}
        {tab === "media" && <MediaSection />}
        {tab === "featured" && <FeaturedTherapistsSection />}
        {tab === "topics" && <HomepageTopicsSection />}
        {tab === "testimonials" && <TestimonialsSection />}
        {tab === "footer" && <FooterSettingsSection />}
      </div>
    </div>
  );
}
